// extracted by mini-css-extract-plugin
export default {"container":"Duration__container___oMV8m","item":"Duration__item___txCT3"};